import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CardRenewalComponent } from './card-renewal.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CardRenewalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CardRenewalRoutingModule { }
